import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserRound } from "lucide-react";
import { AppText, Logo } from "./ui";
import { getSavedProfile } from "../lib/api";

export const NAV = [
  { label: "La méthode", href: "/methode" },
  { label: "Tarifs", href: "/tarifs" },
  { label: "À propos", href: "/a-propos" },
  { label: "Contact", href: "/contact" },
];

export const DISCLAIMER =
  "Ce site a une vocation informative et pédagogique et ne remplace pas l'avis d'un professionnel de santé. En cas de douleur persistante, consulte un médecin.";

export function PageShell({ children, title, wide }) {
  const navigate = useNavigate();
  const goSubscribe = () => {
    const pid = getSavedProfile();
    navigate(pid ? `/resultat/${pid}` : "/tarifs");
  };
  return (
    <div className="min-h-screen bg-km-cream">
      <div className="mx-auto w-full px-4 pb-8" style={{ maxWidth: wide ? 1040 : 640 }}>
        <div className="flex flex-wrap items-center justify-between gap-2 min-h-[64px] pt-4 pb-2">
          <Link to="/" data-testid="nav-logo"><Logo /></Link>
          <nav className="flex flex-wrap justify-end gap-1.5">
            <Link to="/programme" data-testid="nav-account"
              className="px-3 min-h-[40px] flex items-center gap-1.5 rounded-full bg-km-ink border border-km-ink font-text font-bold text-[14px] text-white hover:bg-km-coral hover:border-km-coral transition-colors order-first">
              <UserRound size={16} strokeWidth={2.5} />
              Mon compte
            </Link>
            {NAV.map((n) => (
              <React.Fragment key={n.href}>
                <Link to={n.href} data-testid={`nav-${n.href.slice(1)}`}
                  className="px-3 min-h-[40px] flex items-center rounded-full bg-white border border-km-border font-text font-bold text-[14px] text-km-ink hover:border-km-coral transition-colors">
                  {n.label}
                </Link>
                {n.href === "/tarifs" ? (
                  <button onClick={goSubscribe} data-testid="nav-subscribe"
                    className="px-4 min-h-[40px] flex items-center rounded-full bg-km-coral border border-km-coral font-text font-bold text-[14px] text-white hover:opacity-90 transition-opacity">
                    S'abonner
                  </button>
                ) : null}
              </React.Fragment>
            ))}
          </nav>
        </div>
        {title ? <AppText variant="display" className="mt-6 mb-4">{title}</AppText> : null}
        <div className="animate-fade-up">{children}</div>
        <Footer />
      </div>
    </div>
  );
}

export function Footer() {
  const links = [
    ...NAV,
    { label: "Mon programme", href: "/programme" },
    { label: "Mentions légales", href: "/mentions-legales" },
    { label: "Confidentialité", href: "/confidentialite" },
    { label: "Espace coach", href: "/coach" },
  ];
  return (
    <footer className="mt-12 pt-6 border-t border-km-divider flex flex-col gap-3">
      <Logo size={28} />
      <div className="flex flex-wrap gap-4">
        {links.map((l) => (
          <Link key={l.href} to={l.href} data-testid={`footer-${l.href.slice(1)}`}
            className="min-h-[44px] flex items-center font-text text-[14px] text-km-muted hover:text-km-coral transition-colors">
            {l.label}
          </Link>
        ))}
      </div>
      <AppText variant="caption" className="text-km-muted leading-5">{DISCLAIMER}</AppText>
      <AppText variant="caption" className="text-km-muted">© {new Date().getFullYear()} KM01 · SAS Fit and Run</AppText>
    </footer>
  );
}
